if (!customElements.get('sizden-gelenler-gallery')) {
  class SizdenGelenlerGallery extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dialog = this.querySelector('.sg-modal');
      this.content = this.querySelector('[data-sg-modal-content]');
      this.closeButton = this.querySelector('[data-sg-close]');
      this.previousButton = this.querySelector('[data-sg-previous]');
      this.nextButton = this.querySelector('[data-sg-next]');
      this.triggers = Array.from(this.querySelectorAll('.sg-card__button'));

      if (!this.dialog || !this.content || this.triggers.length === 0) return;

      this.dataset.initialized = 'true';
      this.index = 0;
      this.lastTrigger = null;

      if (this.triggers.length === 1) {
        this.setAttribute('data-single-item', '');
      }

      this.triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', () => this.open(index));
      });

      this.closeButton.addEventListener('click', () => this.close());
      this.previousButton.addEventListener('click', () => this.activate(this.index - 1));
      this.nextButton.addEventListener('click', () => this.activate(this.index + 1));

      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      });

      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });

      this.dialog.addEventListener('close', () => this.afterClose());

      this.handleKeydown = (event) => {
        if (!this.dialog.open) return;

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.activate(this.index - 1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.activate(this.index + 1);
        }
      };

      document.addEventListener('keydown', this.handleKeydown);
    }

    disconnectedCallback() {
      if (this.handleKeydown) {
        document.removeEventListener('keydown', this.handleKeydown);
      }
    }

    open(index) {
      this.lastTrigger = this.triggers[index];
      this.activate(index);

      if (typeof this.dialog.showModal === 'function') {
        if (!this.dialog.open) this.dialog.showModal();
      } else {
        this.dialog.setAttribute('open', '');
      }

      document.documentElement.classList.add('sg-modal-is-open');
      requestAnimationFrame(() => this.closeButton.focus());
    }

    close() {
      this.stopMedia();

      if (typeof this.dialog.close === 'function' && this.dialog.open) {
        this.dialog.close();
      } else {
        this.dialog.removeAttribute('open');
        this.afterClose();
      }
    }

    afterClose() {
      document.documentElement.classList.remove('sg-modal-is-open');
      this.content.replaceChildren();

      if (this.lastTrigger) {
        this.lastTrigger.focus();
      }
    }

    activate(requestedIndex) {
      const itemCount = this.triggers.length;
      const normalizedIndex = (requestedIndex + itemCount) % itemCount;
      const trigger = this.triggers[normalizedIndex];
      const template = trigger.closest('.sg-card').querySelector('.sg-card__template');

      if (!template) return;

      this.stopMedia();
      this.content.replaceChildren(template.content.cloneNode(true));
      this.index = normalizedIndex;
      this.dialog.setAttribute('aria-label', `${trigger.getAttribute('aria-label')} (${normalizedIndex + 1}/${itemCount})`);
      this.hydrateActiveMedia(trigger);
    }

    hydrateActiveMedia(trigger) {
  const gridImage = trigger.querySelector('.sg-card__image');
  const immediateSource = gridImage?.currentSrc || gridImage?.src;
  const image = this.content.querySelector('.sg-modal__image');

  if (image) {
    const loadFullImage = () => {
      if (!this.content.contains(image)) return;

      image.src = image.dataset.src;
      image.srcset = image.dataset.srcset;
      image.sizes = image.dataset.sizes;
    };

    if (immediateSource) {
      image.src = immediateSource;
      window.setTimeout(loadFullImage, 80);
    } else {
      loadFullImage();
    }
  }

  const video = this.content.querySelector('.sg-modal__video');

  if (video) {
    video.poster = immediateSource || video.dataset.poster;

    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
    });

    video.load();
  }
}

    stopMedia() {
      this.content.querySelectorAll('video').forEach((video) => {
        video.pause();

        try {
          video.currentTime = 0;
        } catch (error) {
          // Video metadata may not have loaded yet; no reset is needed in that case.
        }
      });
    }
  }

  customElements.define('sizden-gelenler-gallery', SizdenGelenlerGallery);
}
